import { fetchJsonResponse } from '@/ai/api'
import { buildCommandPrompt } from '@/ai/prompts'

export const generateCommand = async ({
  eventId,
  workflow,
  cardTypes,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildCommandPrompt({
    eventId,
    workflow,
    cardTypes
  })

  const response = await fetchJsonResponse({
    messages,
    useCase: 'commands',
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
